import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    if (this.hasModalTarget) {
      this.modal = new Modal(this.modalTarget)
      this.modal.show()
    }
  }

  disconnect() {
    if (this.modal) {
      this.modal.hide()
    }
  }
}
